import { useEffect, useState } from 'react';

import changelog from '../generated/changelog';
import { isRecentChangelogRelease, parseChangelogVersion } from '../utils/parseChangelog';

export default function useRecentRelease(version: string, days = 7) {
  const [isRecent, setIsRecent] = useState(false);
  const [releaseDateLabel, setReleaseDateLabel] = useState<string>();

  useEffect(() => {
    let ignore = false;

    const loadReleaseInfo = async () => {
      try {
        const parsed = parseChangelogVersion(changelog, version);
        if (!parsed || ignore) return;

        setReleaseDateLabel(parsed.date);
        setIsRecent(isRecentChangelogRelease(parsed.date, days));
      } catch {
        if (!ignore) {
          setIsRecent(false);
          setReleaseDateLabel(undefined);
        }
      }
    };

    loadReleaseInfo();

    return () => {
      ignore = true;
    };
  }, [version, days]);

  return { isRecent, releaseDateLabel };
}
